"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_VALUE = exports.DEFAULT_ACTION_CONFIG = exports.TYPE = void 0;
const translation_1 = require("../../../translation");
const types_1 = require("./types");
const constants_1 = require("../../constants");
exports.TYPE = 'button';
exports.DEFAULT_ACTION_CONFIG = {
    action: types_1.ButtonBlockAction.validate,
    actionType: types_1.ButtonActionType.blockAction,
    label: (0, translation_1.t)('elements.button.label'),
};
exports.DEFAULT_VALUE = {
    label: (0, translation_1.t)('elements.button.label'),
    secondLabel: (0, translation_1.t)('elements.button.label'),
    thirdLabel: (0, translation_1.t)('elements.button.label'),
    fourthLabel: (0, translation_1.t)('elements.button.label'),
    actionType: types_1.ButtonActionType.link,
    actionData: {
        file: constants_1.imageValue,
    },
    correct: exports.DEFAULT_ACTION_CONFIG,
    incorrect: exports.DEFAULT_ACTION_CONFIG,
};
